import stickybits from 'stickybits'

import { CLASS_NAME } from 'constants/class-names'
import { EventType } from 'constants/enums'
import { ComponentBase } from 'utils/abstract-classes/component-base'
import { CSSUtils } from 'utils/css'

const {
    header: headerClass,
    header: { scroll: scrollClass }
} = CLASS_NAME

export class Scroll extends ComponentBase {
    // eslint-disable-next-line no-magic-numbers
    private readonly HEADER_SHRINK_THRESHOLD = 50

    private isShrank = false
    private lastPosition = 0

    public constructor() {
        super()

        window.addEventListener(EventType.SCROLL, () =>
            this.handleScrollEvent()
        )

        // Polyfill for sticky for IE11 and all browsers
        stickybits(`.${headerClass.sticky}`)
    }

    /**
     * Check where the user scrolled
     * confirm against rules and return or show/shrink the header
     */
    private handleScrollEvent(): void {
        const pageYOffset = window.pageYOffset

        if (this.lastPosition > pageYOffset) {
            // scrolling up
            if (this.isShrank) {
                this.showHeader()
            }
        } else if (
            window.innerHeight + pageYOffset >=
            document.documentElement.scrollHeight
        ) {
            // at bottom
            this.showHeader()
        } else if (
            !this.isShrank &&
            pageYOffset >= this.HEADER_SHRINK_THRESHOLD
        ) {
            // scrolling down past threshold
            this.shrinkHeader()
        }

        this.lastPosition = pageYOffset
    }

    /**
     * show the full header
     * CSS dependency
     */
    private showHeader(): void {
        this.isShrank = false
        CSSUtils.removeClass(this.html, scrollClass.shrink)
    }

    /**
     * shrink the header
     * CSS dependency
     */
    private shrinkHeader(): void {
        this.isShrank = true
        CSSUtils.addClass(this.html, scrollClass.shrink)
    }
}
